/* import __COLOCATED_TEMPLATE__ from './team-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';

interface ComponentAttrs {
  team: any;
}

interface SelectItem {
  text: string;
  value: number;
  isSelected: boolean;
  isDisabled: boolean;
  component: string;
}

interface Signature {
  Args: {
    item: SelectItem;
    componentAttrs: ComponentAttrs;
  };
  Element: HTMLDivElement;
}

const TeamSelectItem = templateOnlyComponent<Signature>();
export default TeamSelectItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teammates::Invites::Configuration::TeamSelectItem': typeof TeamSelectItem;
    'settings/teammates/invites/configuration/team-select-item': typeof TeamSelectItem;
  }
}
